import { DefaultTreatments } from '../types';

export function isFeatureFlagEnabled(
  value: DefaultTreatments | undefined | null,
) {
  return value === 'on';
}
